import { render, staticRenderFns } from "./RegionAdd.vue?vue&type=template&id=4b66bb67&scoped=true&"
import script from "./RegionAdd.vue?vue&type=script&lang=js&"
export * from "./RegionAdd.vue?vue&type=script&lang=js&"
import style0 from "./RegionAdd.vue?vue&type=style&index=0&id=4b66bb67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66bb67",
  null
  
)

export default component.exports